export enum AccountTier {
    New = 0,
    Trusted = 1,
    Vip = 2,
}
